import _ from 'lodash';
import { Fragment, useState, useEffect, useRef } from "react";
import moment from 'moment';
import { useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";

//Components
import DataView from 'Components/DataView';
import { Select, Tooltip, Modal, ModalBody, ModalFooter, Button } from '@gpstrackit/react-controls';
import Filters from 'Components/Filters';

//Views
import ChangeDetails from '../changeDetails'
import ShowJSONCompare from '../../../.common/.components/showJSONCompare';
import GeneralDetails from 'Modules/activities/.components/generalDetails';

//Actions
import {
    activitiesSearchDataRequest,
    activitiesSearchUsersTabRequest,
    searchEntityRequest,
    showJSONCompareModal,
    generalAuditLogsOpenModal,
    activitiesSearchCloseModal,
    clearRedux,
} from "Redux/actions";

import InfoIcon from '@mui/icons-material/Info';
import { Grid, IconButton } from "@mui/material";
//Options
import { optionsTimeFrame } from 'Core/defaultValues';
import { getTimeFrame } from 'Utils/helpers';
import { getDateFormatted, getQuery, getPMUser } from 'Core/data/Helpers';

//Styles
import './tab.scss';
import en from "./lan/en";

const ActivitiesTab = (props) => {
    const { entityId, entityName, companyId, height, noFilters2, noOpenSearch2, noUsers, companyName, companyUsername, modalView, entity, instanceId: propInstanceId } = props;

    // Generate unique instanceId if not provided
    const instanceIdRef = useRef(propInstanceId || `activities-${entity}-${Date.now()}-${Math.random()}`);
    const instanceId = instanceIdRef.current;

    let optionsTime = optionsTimeFrame();
    const tableRefAct = useRef();
    const dispatch = useDispatch();
    const { messages } = useIntl();

    //Redux States
    const openModalShowJSONCompare = useSelector(state => state.showJSONCompareRedux.openModal);
    const generalDetailsOpenModal = useSelector(state => state.generalDetailsRedux.openModal);
    const instanceState = useSelector(state => state.activitiesTabRedux.instances[instanceId] || {});
    const { loading, nextToken, entityId: stateEntityId, entityName: stateEntityName, companyId: stateCompanyId } = instanceState;
    const currentEntityId = entityId || stateEntityId;
    const currentEntityName = entityName || stateEntityName;
    const currentCompanyId = companyId || stateCompanyId;
    const activities = instanceState[entity];
    const { users, openModal } = useSelector(state => state.activitiesTabRedux);
    const pmUsers = useSelector(state => state.generalRedux.pmUsers);

    //Local States
    const [timeFrame, setTimeFrame] = useState(optionsTime[2]);
    const [dataToCompare, setDataToCompare] = useState(null);
    const [conditions, setConditions] = useState(null);
    const [username, setUsername] = useState(null);
    const [search, setSearch] = useState(null);
    const [tags, setTags] = useState([]);
    const [last, setLast] = useState({ id: '20', name: '20' });
    const [type, setType] = useState('last');

    const current_week = moment().startOf('week');
    const tempStartDate = new Date(current_week.toString());
    const [startDate, setStartDate] = useState(tempStartDate);
    const [endDate, setEndDate] = useState(new Date());
    const [beforeRangeDate, setBeforeRangeDate] = useState({
        start: tempStartDate,
        end: endDate
    })
    const [currentRow, setCurrentRow] = useState(null);

    const mergeObjects = (target, source) => {
        for (let key in source) {
            if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
                if (!target[key]) {
                    target[key] = {};
                }
                mergeObjects(target[key], source[key]);
            } else {
                target[key] = source[key];
            }
        }
        return target;
    }

    const [columns2, setColumns] = useState([
        {
            key: 'create_at',
            title: messages['activities_tab_created_at'],
            width: 200,
            show: true,
            resize: true,
            export: true,
            functionString: `
            function formatDate(date) {
                let dateToformat = moment(date)
                let formatted = moment(dateToformat).format("YYYY/MM/DD HH:mm:ss")
                return formatted;
              }
            return row?.updatedOn ? formatDate(row?.updatedOn) : ''
            `,
            code: "activities_tab_created_at",
            render: (item) => {
                return <span>{item?.updatedOn && getDateFormatted(item?.updatedOn, "date", "datetime")}</span>
            }
        },
        {
            key: 'platform',
            title: messages['activities_tab_platform'],
            show: true,
            width: 200,
            resize: true,
            export: true,
            functionString: 'return row?.platform',
            code: "activities_tab_platform",
            render: (item) => {
                return <span>{item?.platform}</span>
            }
        },
        {
            key: 'controller',
            title: messages['activities_tab_controller'],
            show: true,
            width: 200,
            resize: true,
            export: true,
            functionString: 'return row?.module',
            code: "activities_tab_controller",
            render: (item) => {
                return <span>{item?.module}</span>
            }
        },
        {
            key: 'method',
            title: messages['activities_tab_method'],
            width: 200,
            show: true,
            resize: true,
            export: true,
            functionString: 'return row?.method',
            code: "activities_tab_method",
            render: (item) => {
                return <span>{item?.method}</span>
            }
        },
        {
            key: 'action',
            title: messages['activities_tab_action'],
            width: 200,
            show: true,
            resize: true,
            export: true,
            functionString: 'return row?.action',
            code: "activities_tab_action",
            render: (item) => {
                return <span>{item?.action}</span>
            }
        },
        {
            key: 'entityId',
            title: messages['activities_tab_entity_id'],
            width: 200,
            show: true,
            resize: true,
            export: true,
            functionString: 'return row?.entityId',
            code: "activities_tab_entity_id",
            render: (item) => {
                return <span>{item?.entityId}</span>
            }
        },
        {
            key: 'urlReferrer',
            title: messages['activities_tab_url'],
            width: 200,
            show: true,
            resize: true,
            export: true,
            functionString: 'return row?.urlReferrer',
            code: "activities_tab_url",
            render: (item) => {
                return <span>{item?.urlReferrer}</span>
            }
        },
        {
            key: 'change',
            title: messages['activities_tab_change'],
            width: 100,
            show: true,
            resize: true,
            export: true,
            functionString: 'return row?.newValues',
            code: "activities_tab_change",
            render: (item) => {
                let newValues
                let parameters
                let currentChange = {
                    action: item?.action,
                    entityName: item?.entityName,
                    ipAddress: item?.ipAddress,
                    username: item?.username,
                    method: item?.method,
                    module: item?.module,
                    platform: item?.platform,
                    source: item?.source,
                    updatedBy: item?.updatedBy,
                    updatedOn: item?.updatedOn && getDateFormatted(item?.updatedOn, "date", "datetime"),
                };
                try {
                    newValues = JSON.parse(item?.newValues);
                    parameters = JSON.parse(item?.parameters);
                    if (item?.method?.includes("updateVidFleetAddConfig") || item?.method?.includes("updateVidFleetOverrideDefaultConfig")) {
                        let data = newValues?.res?.settings /* || newValues?.settings */ || {}
                        let newParameters = _.merge(JSON.parse(JSON.stringify(data)), JSON.parse(JSON.stringify(parameters?.settings)));
                        currentChange.newValues = data;
                        currentChange.parameters = newParameters;
                    } else {
                        if (newValues)
                            currentChange = {
                                ...currentChange,
                                ...newValues,
                            }
                        if (parameters) {
                            currentChange = {
                                ...currentChange,
                                ...parameters.vehicleInformation,
                            }
                        }
                    }
                } catch (error) { }
                return (
                    <div>
                        <Tooltip title={messages['common_show_changes']}>
                            <IconButton
                                onClick={() => {
                                    if (currentChange?.method?.includes("updateVidFleetAddConfig") || currentChange?.method?.includes("updateVidFleetOverrideDefaultConfig")) {
                                        setDataToCompare(currentChange);
                                        dispatch(showJSONCompareModal());
                                        if (item?.platform === "PX") {
                                            setCurrentRow(item?.id)
                                        }
                                    } else {
                                        let changes = JSON.parse(item?.parameters)
                                        dispatch(generalAuditLogsOpenModal(
                                            true,
                                            item?.entityName === "Device" ? "Unit" : item?.entityName,
                                            item?.entityId,
                                            companyId,
                                            item?.id,
                                            item?.updatedOn,
                                            changes,
                                            item?.action,
                                            item?.method
                                        ))
                                    }
                                }}
                                size="large">
                                <InfoIcon />
                            </IconButton>
                        </Tooltip>
                    </div>
                );
            }
        },
        {
            key: 'create_by',
            title: messages['activities_tab_created_by'],
            width: 200,
            show: true,
            resize: true,
            export: true,
            functionString: `
                if(row?.platform === "PM"){
                    let pmUsers = ${JSON.stringify(pmUsers)}
                    pmUsers = pmUsers.find((item) => item.username === row?.username)
                    return pmUsers.firstName + " " + pmUsers.lastName || row?.username
                } else {
                    let pxUsers = ${JSON.stringify(users)}
                    let regexSubUser = /^PX_\d+_\d+$/;
                    if (regexSubUser.test(row?.updatedBy)) {
                        let id = row?.updatedBy.split("_")[2];
                        let user = pxUsers.find((item) => (item?.id == +id))
                        return user?.userName
                    } else {
                        return ${companyName ? JSON.stringify(companyName) : ""}
                    }
                }
            `,
            code: "activities_tab_created_by",
            render: (item) => {
                return <span>{item?.updatedBy && item?.platform === "PM" ? getPMUser(item?.updatedBy, pmUsers) : accountValidation(item?.updatedBy, users)}</span>
            }
        }
    ]);


    const activityHandler = (newTime, newTags, refresh, newUsername, clearUsername = false) => {
        let currentConditions = tableRefAct?.current?.conditions;
        if (newTime || newTags || refresh || newUsername) {
            dispatch(clearRedux("ACTIVITIES_TAB", { nextToken: null, [entity]: [] }, instanceId));
        }
        let currentTags = tags
        if (newTags) {
            //Delete Tags
            let deleteTags = currentConditions.findIndex((item) => item.fields[0] === "openSearch");
            deleteTags >= 0 && currentConditions.splice(deleteTags, 1);
            currentConditions.push({ fields: ["openSearch"], terms: newTags });
            tableRefAct?.current?.conditionsHandler(currentConditions);
            setTags(newTags);
            currentTags = newTags
        }
        let currentOpenSearch = currentTags;

        let payload = {
            opensearch: noOpenSearch2 ? [] : currentOpenSearch,
            action: ["insert", "update", "delete", "other"],
        }

        if (currentCompanyId) {
            payload.accountId = currentCompanyId;
        }

        if (type === 'last') {
            payload.lastRecords = last.id || 20
            payload.dateRange = {
                start: new Date('2000-01-01'),
                end: new Date(),
            }
        } else {
            let newEndDate = newTime?.end || endDate;
            newEndDate.setHours(23, 59, 59, 0)
            payload.dateRange = {
                start: newTime?.start || startDate,
                end: newEndDate,
            }
        }

        const value = payload.opensearch.length ? payload.opensearch[0][Object.keys(payload.opensearch[0])[0]] : null
        payload.opensearch = value ? [value] : []

        if (username?.userName && !clearUsername) {
            payload.username = username?.userName
        }
        if (nextToken && !newTime && !newTags && !refresh && !newUsername) {
            payload.nextToken = nextToken
        }
        if (currentEntityId && currentEntityName !== "Company") {
            payload.entity = {
                name: currentEntityName || "Unit",
                id: `${currentEntityId}`
            }
        }
        if (newUsername) {
            payload.username = newUsername
            setUsername(newUsername);
        }

        !nextToken && !refresh && dispatch(clearRedux("ACTIVITIES_TAB", { [entity]: [] }, instanceId))
        dispatch(activitiesSearchDataRequest(payload, entity, instanceId)); //activitiesAccounts
        setConditions(payload)
    }

    const applyFilters = () => {
        activityHandler(null, null, true);
        //save preferences
        let currentConditions = tableRefAct?.current?.conditions;

        //Delete
        let deleteTimeFrame = currentConditions.findIndex((item) => item.fields[0] === "timeframe");
        deleteTimeFrame >= 0 && currentConditions.splice(deleteTimeFrame, 1);

        let newEndDate = endDate;
        newEndDate.setHours(23, 59, 59, 0)

        //Add
        currentConditions.push({ fields: ["timeframe"], terms: { startDate, newEndDate, type, last } })
        tableRefAct?.current?.conditionsHandler(currentConditions);
    }

    const usersHandler = (item) => {
        let filter = item?.userName
        if (/\s/.test(filter) && companyUsername) {
            filter = companyUsername
        }
        activityHandler(null, null, true, filter, !item ? true : false);

        //save preferences
        let currentConditions = tableRefAct?.current?.conditions;

        //Delete
        let deleteUsername = currentConditions.findIndex((item) => item.fields[0] === "username");
        deleteUsername >= 0 && currentConditions.splice(deleteUsername, 1);

        if (item)
            currentConditions.push({ fields: ["username"], terms: item })

        tableRefAct?.current?.conditionsHandler(currentConditions);
        setUsername(item);

    }

    const accountValidation = (name, list) => {
        let createdBy = name
        let regexSubUser = /^PX_\d+_\d+$/;
        if (name.includes("PX")) {
            if (regexSubUser.test(name)) {
                try {
                    let id = name.split("_")[2];
                    let user = list.find((item) => (item?.id == +id))
                    createdBy = user?.userName
                } catch (error) { }
            } else {
                createdBy = companyName
            }
        }
        return createdBy || name
    }

    const onChange = (value) => {
        const { start, end } = value;
        onChangeStartEndDate({
            start,
            end
        })


    };

    const onChangeStartEndDate = ({ start, end }) => {
        const newStart = start && new Date(start);
        const newEnd = end && new Date(end);
        if (start && end) {
            //save preferences
            let currentConditions = tableRefAct?.current?.conditions;

            //Delete
            let deleteTimeFrame = currentConditions.findIndex((item) => item.fields[0] === "timeframe");
            deleteTimeFrame >= 0 && currentConditions.splice(deleteTimeFrame, 1);

            //Add
            currentConditions.push({ fields: ["timeframe"], terms: { start, end, type, last } })
            tableRefAct?.current?.conditionsHandler(currentConditions);
        }

    }

    const getComponentRender = () => {
        if (modalView) {
            return renderModal()
        }
        return renderTab()
    }

    const renderTab = () => {
        return (
            <div style={{ marginTop: 10 }}>
                <DataView
                    ref={tableRefAct}
                    exportName="activities"
                    placeholderSearch={messages['activities_tab_search_by_controller']}
                    name={companyId ? `pm-activities-tab-${companyId}-v1-${currentEntityName}-${currentEntityId}` : `pm-activities-tab-v1-${currentEntityName}-${currentEntityId}`}
                    externalData={activities || []}
                    externalLoading={loading}
                    disableItemSelection
                    noFilters={noFilters2}
                    externalRefresh={() => activityHandler(null, null, true)}
                    columns={columns2}
                    noSplit
                    noTags
                    height={height || 500}
                    infiniteScroll={type !== 'last'}
                    nextToken={nextToken}
                    noAutomaticSearch
                    noSearch={noFilters2}
                    maxTags={1}
                    noSearchOptions
                    exportLimit={type === 'last' ? (Number(last.id) || 20) : undefined}
                    extraFilters={() => {
                        return (
                            <div className="extra-filters-tab" style={{ width: noFilters2 && '100%', justifyContent: noFilters2 && 'end' }}>

                                {
                                    !noUsers &&
                                    <Select
                                        id="users"
                                        placeholder={messages['activities_tab_username']}
                                        options={users}
                                        value={username}
                                        textField="userName"
                                        valueField="id"
                                        onChange={(items = []) => usersHandler(items)}
                                        isClearable
                                    />
                                }
                                <Filters

                                    onChangeFilters={() => applyFilters()}
                                    startDate={startDate}
                                    endDate={endDate}
                                    setStartDate={setStartDate}
                                    setEndDate={setEndDate}
                                    setBeforeRangeDate={setBeforeRangeDate}
                                    beforeRangeDate={beforeRangeDate}
                                    onChange={onChange}
                                    onChangeStartEndDate={onChangeStartEndDate}
                                    last={last}
                                    setLast={setLast}
                                    type={type}
                                    setType={setType}
                                />
                            </div>
                        )
                    }}
                    onChangePage={() => activityHandler()}
                    tableButtons={["export", 'orderColumn']}
                    onChangeColumns={(items) => setColumns(items)}
                    onChangeConditions={(newTags, newConditions, total, newColumns, rows, sort) => {
                        if (newTags) {
                            activityHandler(null, newTags)
                        } else {
                            let payload = {
                                dateRange: {
                                    start: startDate,
                                    end: endDate,
                                },
                                opensearch: [],
                                action: ["insert", "update", "delete", "other"]
                            }
                            if (currentCompanyId) {
                                payload.accountId = currentCompanyId;
                            }
                            //Username
                            let validateUsername = newConditions && newConditions?.find((tag) => tag?.fields && tag?.fields[0] === "username");
                            if (username) {
                                payload.username = /\s/.test(username) && companyUsername ? companyUsername : username
                            }

                            //Tags
                            let validateSearch = newConditions && newConditions?.find((tag) => tag?.fields && tag?.fields[0] === "openSearch");
                            if (validateSearch) {
                                setTags(validateSearch?.terms || [])
                                tableRefAct?.current?.setTags(validateSearch?.terms);
                                payload.opensearch = noOpenSearch2 ? [] : validateSearch?.terms
                            }
                            //Time Frame

                            if (type === 'last') {
                                payload.lastRecords = last?.id || 20;
                                payload.dateRange = {
                                    start: new Date('2000-01-01'),
                                    end: new Date(),
                                }
                            } else {
                                payload.dateRange.start = startDate;
                                payload.dateRange.end = endDate;
                            }

                            if (currentEntityId && currentEntityName !== "Company") {
                                payload.entity = {
                                    name: currentEntityName || "Unit",
                                    id: `${currentEntityId}`
                                }
                            }
                            setConditions(payload)

                            const value = payload.opensearch.length ? payload.opensearch[0][Object.keys(payload.opensearch[0])[0]] : null
                            payload.opensearch = value ? [value] : []

                            //review
                            currentEntityName && dispatch(activitiesSearchDataRequest(payload, entity, instanceId));
                        }
                    }}
                    query={getQuery("user-activitys-logs")}
                    isDynamo
                    conditions={conditions}
                    noPDF
                    hidePagination
                />
            </div>
        )
    }

    const renderModal = () => {
        return (
            <Modal
                open={openModal}
                title={messages['activities_tab_title']}
                size="large"
                position="right"
                handleClose={() => close()}
            >
                <ModalBody>
                    <Grid container spacing={2} className="modal-body">
                        <Grid item xs={12} className="modal-body-content">
                            {
                                renderTab()
                            }
                        </Grid>
                    </Grid>
                </ModalBody>
                <ModalFooter>
                    <div>
                        {
                            <Button size="lg" className="btn btn-cancel"
                                onClick={() => {
                                    close();
                                }}
                                disabled={loading}
                            >
                                {messages["common_cancel"]}
                            </Button>
                        }
                    </div>
                </ModalFooter>
            </Modal>
        )
    }

    const close = () => {
        dispatch(activitiesSearchCloseModal());
    }

    useEffect(() => {
        if (search || search === "") {
            const timer = setTimeout(() => {
                activityHandler(null, search);
                //Save preference
                let currentConditions = tableRefAct?.current?.conditions;

                //Delete
                let deleteOpenSearch = currentConditions.findIndex((item) => item.fields[0] === "opensearch");
                deleteOpenSearch >= 0 && currentConditions.splice(deleteOpenSearch, 1);

                //Add
                currentConditions.push({ fields: ["opensearch"], terms: { search } });
                tableRefAct?.current?.conditionsHandler(currentConditions);
            }, 500)
            return () => clearTimeout(timer);
        }
        return () => {
            dispatch(clearRedux("ACTIVITIES_TAB", { [entity]: [] }, instanceId))
        }
    }, [search])

    useEffect(() => {
        if (companyId) dispatch(activitiesSearchUsersTabRequest(companyId, "companyId", companyName));
        dispatch(searchEntityRequest({ key: "pmUsers" }));
        return () => {
            dispatch(clearRedux("ACTIVITIES_TAB", { users: [] }, instanceId));
        }
    }, []);

    useEffect(() => {
        if (pmUsers.length || users.length) {
            let currentColumns = [...columns2]
            let index = currentColumns.findIndex((item) => item.key === "create_by")
            if (index > -1) {
                currentColumns[index].functionString = `
                    if(row?.platform === "PM"){
                        let pmUsers = ${JSON.stringify(pmUsers)}
                        pmUsers = pmUsers.find((item) => item.username === row?.username)
                        return pmUsers.firstName + " " + pmUsers.lastName || row?.username 
                    } else {
                        let pxUsers = ${JSON.stringify(users)}
                        let regexSubUser = /^PX_\d+_\d+$/;
                        if (regexSubUser.test(row?.updatedBy)) {
                            let id = row?.updatedBy.split("_")[2];
                            let user = pxUsers.find((item) => (item?.id == +id))
                            return user?.userName
                        } else {
                            return ${companyName ? JSON.stringify(companyName) : ""}
                        }
                    }`
                currentColumns[index].render = (item) => {
                    return <span>{item?.updatedBy && item?.platform === "PM" ? getPMUser(item?.updatedBy, pmUsers) : accountValidation(item?.updatedBy, users)}</span>
                }
            }
            setColumns([...currentColumns])
        }
    }, [pmUsers, users])

    return (
        <Fragment>

            {getComponentRender()}

            <ChangeDetails />
            {
                openModalShowJSONCompare &&
                <ShowJSONCompare
                    title={messages["activities_tab_title_vidfleet_compare"]}
                    oldData={dataToCompare && dataToCompare.newValues && JSON.parse(JSON.stringify(dataToCompare.newValues))}
                    newData={dataToCompare && dataToCompare.parameters && JSON.parse(JSON.stringify(dataToCompare.parameters))} />
            }
            {generalDetailsOpenModal && <GeneralDetails />}
        </Fragment>
    )
}

export default ActivitiesTab;